import { observer } from 'mobx-react';
import { RootStore, withInjectedRootStore } from '../../providers';
import * as React from 'react';
import { getFaqs } from '../../utils';
import { FaqSideSubtitle } from '../Faq/FaqSubtitle';
import { Theme } from '../../enums';
import { FaqSection } from '@wix/package-picker-components';
import { useTranslation } from 'react-i18next';

export interface StudioFaqProps {
  rootStore: RootStore;
}

// TODO: change component name once the old faw component is removed and the faqs are coming from dealer
const StudioFaqComp: React.FC<StudioFaqProps> = ({ rootStore }) => {
  const { t } = useTranslation();
  const { hasGoogleVoucher, country } = rootStore.appStore.appContext;

  const studioFaqs = getFaqs({
    theme: Theme.WixStudio,
    hasGoogleVoucher,
    country,
  }).map((faq) => ({
    question: t(`${faq}.question`),
    answer: t(`${faq}.answer`),
  }));

  return (
    <FaqSection
      faq={studioFaqs}
      title={t('faq_section.faq_title')}
      subtitle={<FaqSideSubtitle />}
    />
  );
};

export const StudioFaq = withInjectedRootStore(observer(StudioFaqComp));
